import { createContext } from 'react';

import type { PieChartContextConfig } from '../types/pie-chart.config.js';

/**
 * @internal
 */
export const PieChartConfigContext = createContext<
  PieChartContextConfig | string
>({});

/**
 * Provider for the PieChart API config that can be shared across charts
 * @public
 */
export const PieChartConfig = PieChartConfigContext.Provider;
/**
 * Provider for the DonutChart API config that can be shared across charts.
 * @public
 */
export const DonutChartConfig = PieChartConfig;
